import { Component, OnInit, Output, ViewChild, ViewEncapsulation, EventEmitter } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from "@angular/forms";
import { Router } from '@angular/router';
import { TextBoxComponent } from "@progress/kendo-angular-inputs";
import { Role } from 'src/app/models/role.model';
import { DoctorService } from 'src/app/services/doctor/doctor.service';
import { ExpertService } from 'src/app/services/expert/expert.service';
import { ExpertService as AdminExpertService } from 'src/app/services/admin/expert.service';
import { User } from '../../models/user.model';
import { UserService } from '../../services/user.service';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { NotificationService } from '@progress/kendo-angular-notification';
import { HospitalService } from 'src/app/services/hospital/hospital.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class LoginComponent implements OnInit {
  @Output() public loginEvent = new EventEmitter();
  user: User;
  @ViewChild("password") password: TextBoxComponent;
  @ViewChild("email") email: TextBoxComponent;
  title = 'kendo-angular-app';
  isLoggingIn = true;
  processing = false;
  TYPE = 1;

  currentUser: any = null;

  constructor(
    private userService: UserService,
    private router: Router,
    private doctor_doctorService: DoctorService,
    private expert_expertService: ExpertService,
    private admin_expertService: AdminExpertService,
    private hospital_hospitalService: HospitalService,
    private firebaseAuth: AngularFireAuth,
    private notificationService: NotificationService,) {
    this.user = new User();
    this.user.email = "";
    this.user.password = "";
    this.currentUser = this.userService.currentUserValue;
  }

  ngOnInit() {
    if (!!this.currentUser) {
      switch (this.currentUser.role) {
        case Role.Admin:
          const currentAdmin = JSON.parse(localStorage.getItem('currentUser'));
          this.expert_expertService.setUser(currentAdmin);
          this.router.navigate(['admin']);
          break;
        case Role.Expert:
          const currentExpert = JSON.parse(localStorage.getItem('currentUser'));
          this.expert_expertService.setUser(currentExpert);
          this.router.navigate(['expert']);
          break;
        case Role.Doctor:
          const currentDoctor = JSON.parse(localStorage.getItem('currentUser'));
          this.doctor_doctorService.setUser(currentDoctor);
          this.router.navigate(['doctor']);
          break;
        case Role.Hospital:
          const currentHospital = JSON.parse(localStorage.getItem('currentUser'));
          this.hospital_hospitalService.setUser(currentHospital);
          this.router.navigate(['hospital']);
          break;
        default:
          break;
      }
    }
  }

  public ngAfterViewInit(): void {
    this.password.input.nativeElement.type = "password";
  }

  public toggleVisibility(): void {
    const inputEl = this.password.input.nativeElement;
    inputEl.type = inputEl.type === "password" ? "text" : "password";
  }

  public form: UntypedFormGroup = new UntypedFormGroup({
    email: new UntypedFormControl(),
    password: new UntypedFormControl(),
    loggedin: new UntypedFormControl(),
  });

  public submit(): void {
    if (this.form.get('email')?.value === '' || this.form.get('password')?.value === '') {
      this.notificationService.show({
        content: 'Enter email and password.',
        animation: { type: 'slide', duration: 500 },
        position: { horizontal: 'center', vertical: 'bottom' },
        type: { style: 'error', icon: true },
        hideAfter: 2000
      });
      return;
    }
    this.user.email = this.form.get('email')?.value;
    this.user.password = this.form.get('password')?.value;
    this.login();
  }

  logoutWrongType() {
    this.userService.logout();
  }

  login() {
    this.userService.login(this.user)
      .then((user) => {
        this.getCurrentUser(user.user.uid);
      })
      .catch((error) => {
        this.notificationService.show({
          content: 'Incorrect credentials.',
          animation: { type: 'slide', duration: 500 },
          position: { horizontal: 'center', vertical: 'bottom' },
          type: { style: 'error', icon: true },
          hideAfter: 5000
        });
        this.processing = false;
      });
  }

  getCurrentUser(userID: string) {
    this.firebaseAuth.currentUser.then((user) => {
      if (user != null) {
        this.processing = false;
        // if (user) {
        //   this.setAdminUser(userID);
        //   // let newUser: any = user;
        //   // newUser.role = 'admin';
        //   // this.processing = false;
        //   // this.userService.logUser(true);
        //   // this.userService.setCurrentUser(newUser);
        //   // this.router.navigate(['admin']);
        // }
        user.getIdTokenResult().then((data) => {
          this.checkClaims(data.claims, userID, user.email);
        }).catch((error) => {
          this.processing = false;
          console.log('getIdTokenResult Error: ', error)
        })
      }
    }).catch((error) => {
      this.processing = false;
      console.log('getCurrentUser Error: ', error)
    });
  }

  checkClaims(claims: any, userID: string, email: string) {
    if (claims.admin != null && claims.admin == true) {
      this.setAdminUser(userID, email);
    } else if (claims.expert != null && claims.expert == true) {
      this.getExpertUser(userID);
    } else if (claims.doctor != null && claims.doctor == true) {
      this.getDoctortUser(userID);
    } else if (claims.hospital != null && claims.hospital == true) {
      this.getHospitalUser(userID);
    } else {
      this.processing = false;
      this.logoutWrongType();
      alert('Unauthorized user.')
    }
  }



  setAdminUser(userID: any, email: string) {
    this.processing = false;

    let newUser = {
      id: userID,
      role: 'admin',
      email: email
    }

    this.processing = false;
    this.userService.logUser(true);
    this.userService.setCurrentUser(newUser);
    this.router.navigate(['admin']);
  }

  public getAdminUser(userID: string): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      resolve(this.admin_expertService.getExpertInformation(userID));
    }).then((user) => {
      this.processing = false;
      if (user) {
        let newUser = user;
        newUser.role = 'admin';
        this.processing = false;
        this.userService.logUser(true);
        this.userService.setCurrentUser(newUser);
        this.router.navigate(['admin']);
      }
    });
  }

  public getExpertUser(userID: string): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      resolve(this.expert_expertService.getExpertInformation(userID));
    }).then((user) => {
      this.processing = false;
      if (user) {
        let newUser = user;
        newUser.role = 'expert'
        // newUser.role = 'admin';
        this.processing = false;
        this.userService.logUser(true);
        this.userService.setCurrentUser(newUser);
        this.router.navigate(['expert']);
        // this.router.navigate(['admin']);
      }
    });
  }

  public getDoctortUser(userID: string): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      resolve(this.doctor_doctorService.getDoctorInformation(userID));
    }).then((user) => {
      this.processing = false;
      if (user) {
        let newUser = user;
        newUser.role = 'doctor';
        this.processing = false;
        this.userService.logUser(true);
        this.userService.setCurrentUser(newUser);
        this.router.navigate(['doctor']);
      }
    });
  }

  public getHospitalUser(userID: string): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      resolve(this.hospital_hospitalService.getHospitalById(userID));
    }).then((user) => {
      this.processing = false;
      if (user) {
        let newUser = user;
        newUser.role = 'hospital';
        this.processing = false;
        this.userService.logUser(true);
        this.userService.setCurrentUser(newUser);
        this.router.navigate(['hospital']);
      }
    });
  }

  public clearForm(): void {
    this.form.reset();
  }


}
